import { Spinner } from "@src/components/elements/Spinner";
import React from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.div`
  background: var(--background-gray);
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  .loading {
    font-weight: var(--font-weight-bold);
  }
`;
export const PageLoading = ({ className }: { className?: string }) => {
  return (
    <StyledRoot className={className}>
      <div className="loading row">
        Loading
        <Spinner size="small" />
      </div>
    </StyledRoot>
  );
};
